import { Base64, Utf8 } from './CryptoJS'

export function doCrypt (token) {
  if (token) {
    const extraString = Base64.stringify(Utf8.parse(token[4] + token[8] + token[15] + token[16] + token[23] + token[42]))
    const string = extraString + token
    const encrypted = Base64.stringify(Utf8.parse(string))
    return Base64.stringify(Utf8.parse(encrypted + extraString.length))
  }
  return null
}

export function doEncrypt (word) {
  if (word) {
    const firstDecoded = Utf8.stringify(Base64.parse(word))
    const length = Number(firstDecoded[firstDecoded.length - 1]) || 0
    const string = Utf8.stringify(Base64.parse(firstDecoded.substring(0, firstDecoded.length - 1)))
    const extraString = string.substring(0, length)
    const token = string.substring(length)
    const decodedExtraString = Utf8.stringify(Base64.parse(extraString))
    if (decodedExtraString === (token[4] + token[8] + token[15] + token[16] + token[23] + token[42])) return token
    return null
  }
  return null
}
